import { Controller } from '@hotwired/stimulus'
import { extractVariableNames } from '../lib/vignette_variables'

export default class extends Controller {
  static targets = ['scenario', 'variablesInput', 'variablesList']
  // `pattern` carries Vignette::VARIABLE_PATTERN.source from the server so the
  // placeholder grammar is defined in one place. See lib/vignette_variables.js.
  static values = { pattern: String }

  connect() {
    this.extractVariables()
  }

  extractVariables() {
    const variables = extractVariableNames(this.scenarioTarget.value, this.patternValue)

    this.variablesInputTarget.value = JSON.stringify(variables)
    this.renderVariableList(variables)
  }

  renderVariableList(variables) {
    if (!this.hasVariablesListTarget) return

    this.variablesListTarget.innerHTML = ''

    if (variables.length === 0) {
      const li = document.createElement('li')
      li.textContent = 'No variables detected yet.'
      li.className = 'italic text-gray-400'
      this.variablesListTarget.appendChild(li)
    } else {
      variables.forEach((variable) => {
        const li = document.createElement('li')
        li.textContent = variable
        li.className = 'text-gray-700'
        this.variablesListTarget.appendChild(li)
      })
    }
  }

  updateVariables() {
    this.extractVariables()
  }
}
